import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import { Skeleton } from 'fpay-ui';

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${theme.breakpoint('md')} {
      margin-top: 55px;
    }
  `
);

const BoxFounds = styled.div(
  ({ theme }) => css`
    background-color: #fff;
    border-radius: 6px;
    width: 100%;
    padding-top: 37px;
    padding-bottom: 32px;
    text-align: center;
    max-width: 500px;
    ${theme.breakpoint('md')} {
      padding-top: 53px;
      padding-bottom: 38px;
    }
  `
);

const BoxBank = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    background-color: #fff;
    border-radius: 6px;
    width: 100%;
    padding-top: 24px;
    padding-bottom: 29px;
    text-align: left;
    padding-left: 22px;
    max-width: 500px;
    ${theme.breakpoint('md')} {
      padding-top: 31px;
      padding-bottom: 33px;
      padding-left: 32px;
    }
  `
);

const BoxFoundsLayoutSales = styled.div``;
const BoxFoundsLayoutMount = styled.div``;
const BoxFoundsLayoutSalesLarge = styled.div`
  margin-top: 33px;
`;

const SkeletonIcon = styled(Skeleton)`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-left: 5px;
`;

const SkeletonTitle = styled(Skeleton)`
  width: 104px;
  height: 22px;
`;

const SkeletonFounds = styled(Skeleton)(
  ({ theme }) => css`
    width: ${(props) => (props.large ? '208px' : '153px')};
    height: ${(props) => (props.large ? '42px' : '25px')};
    ${theme.breakpoint('md')} {
      width: ${(props) => (props.large ? '294px' : '221px')};
      height: ${(props) => (props.large ? '45px' : '35px')};
    }
  `
);

const SkeletonButton = styled(Skeleton)`
  margin-top: 4px;
  width: 216px;
  height: 48px;
`;

const SkeletonTitlesBank = styled(Skeleton)(
  ({ theme }) => css`
    display: flex;
    width: ${(props) => (props.large ? '251px' : props.medium ? '183px' : '104px')};
    height: 20px;
    margin-top: ${(props) => (props.large ? '0px' : props.medium ? '4px' : '4px')};
    ${theme.breakpoint('md')} {
      display: ${(props) => (props.large ? 'flex' : props.medium ? 'flex' : 'none')};
      height: 22px;
      width: ${(props) => (props.large ? '311px' : props.medium ? '184px' : 'none')};
    }
  `
);

const SkeletonFoundsOut = ({
  viewBankAccount = true,
  viewWithdrawMoney = true,
  viewAdvancementButton = true,
}) => (
  <Layout>
    <BoxFounds>
      <BoxFoundsLayoutSales>
        <SkeletonTitle />
        <SkeletonIcon />
        <BoxFoundsLayoutMount>
          <SkeletonFounds />
        </BoxFoundsLayoutMount>
        {viewAdvancementButton && <SkeletonButton />}
      </BoxFoundsLayoutSales>
      <BoxFoundsLayoutSalesLarge>
        <SkeletonTitle />
        <SkeletonIcon />
      </BoxFoundsLayoutSalesLarge>
      <BoxFoundsLayoutMount>
        <SkeletonFounds large />
      </BoxFoundsLayoutMount>
      {viewWithdrawMoney && <SkeletonButton />}
    </BoxFounds>
    {viewBankAccount && (
      <BoxBank>
        <SkeletonTitlesBank large />
        <SkeletonTitlesBank />
        <SkeletonTitlesBank medium />
      </BoxBank>
    )}
  </Layout>
);

export default SkeletonFoundsOut;

SkeletonFoundsOut.defaultProps = {
  viewBankAccount: true,
  viewWithdrawMoney: true,
};

SkeletonFoundsOut.propTypes = {
  viewBankAccount: PropTypes.bool,
  viewWithdrawMoney: PropTypes.bool,
};
